export default "__VITE_ASSET__a71fad31__"